<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="oe-question">
        <span class="oe-bar oe-bar--xl"></span>
        <span class="oe-bar oe-bar--md"></span>
      </div>
      <div class="oe-stream">
        <div
          v-for="(msg, i) in messages"
          :key="msg.text"
          class="oe-card"
          :style="{ '--card-i': i }"
        >
          <span class="oe-card-author">{{ msg.author }}</span>
          <span class="oe-card-text">{{ msg.text }}</span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="oe-phone-q"></span>
      <div class="oe-phone-input">
        <span class="oe-phone-typed">More flexibility<span class="oe-caret">|</span></span>
      </div>
      <button type="button" class="oe-phone-send" tabindex="-1">
        <span class="material-symbols-rounded">send</span>
        Send
      </button>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewOpenEnded',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
  data() {
    return {
      messages: [
        { author: 'Alex', text: 'More remote-work flexibility' },
        { author: 'Sam', text: 'Better onboarding docs' },
        { author: 'Priya', text: 'Faster code reviews' },
        { author: 'Lin', text: 'Clearer roadmaps' },
      ],
    }
  },
})
</script>

<style scoped lang="scss">
.oe-bar {
  display: block; height: 8px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.oe-bar--xl { width: 70%; }
.oe-bar--md { width: 40%; }

.oe-question {
  display: flex; flex-direction: column; gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}
.oe-question .oe-bar:first-child { background: rgba(15, 15, 20, 0.2); }

.oe-stream {
  display: grid; gap: 6px;
  min-height: 110px;
  align-content: flex-start;
}
.oe-card {
  background: color-mix(in srgb, var(--accent) 10%, white);
  border: 1px solid color-mix(in srgb, var(--accent) 25%, transparent);
  border-radius: 8px;
  padding: 6px 9px;
  display: grid; gap: 1px;
  opacity: 0;
  transform: translateY(8px);
  animation: oe-slide 4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  animation-delay: calc(var(--card-i, 0) * 350ms + 500ms);
}
.oe-card-author {
  font-size: 9px; font-weight: 700; letter-spacing: 0.04em;
  color: var(--accent); text-transform: uppercase;
}
.oe-card-text {
  font-size: 11px; font-weight: 600;
  color: rgba(15, 15, 20, 0.78);
}

/* ---- Audience phone ---- */
.oe-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.oe-phone-input {
  border: 1px solid color-mix(in srgb, var(--accent) 50%, transparent);
  border-radius: 8px;
  padding: 12px 10px;
  min-height: 44px;
  background: white;
}
.oe-phone-typed {
  font-size: 12px; font-weight: 600;
  color: rgba(15, 15, 20, 0.85);
}
.oe-caret {
  color: var(--accent);
  animation: oe-blink 1s steps(2) infinite;
}
.oe-phone-send {
  appearance: none; border: none;
  background: var(--accent); color: white;
  font-family: inherit; font-weight: 700; font-size: 12px;
  border-radius: 8px;
  padding: 8px 12px;
  display: flex; align-items: center; justify-content: center; gap: 4px;
  cursor: pointer;
  animation: oe-tap 4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
.oe-phone-send .material-symbols-rounded { font-size: 14px; }

@keyframes oe-slide {
  0%, 5%   { opacity: 0; transform: translateY(8px); }
  20%      { opacity: 1; transform: translateY(0); }
  92%, 100% { opacity: 1; transform: translateY(0); }
}
@keyframes oe-blink {
  0% { opacity: 1; } 100% { opacity: 0; }
}
@keyframes oe-tap {
  0%, 60%   { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 35%, transparent); }
  72%       { box-shadow: 0 0 0 8px color-mix(in srgb, var(--accent) 0%, transparent); }
  100%      { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 0%, transparent); }
}

@media (prefers-reduced-motion: reduce) {
  .oe-card { animation: none; opacity: 1; transform: none; }
  .oe-caret, .oe-phone-send { animation: none; }
}
</style>
